// extracted by mini-css-extract-plugin
export var container = "Title-module--container--6PCwa";
export var titleHero = "Title-module--titleHero--hpGXn";
export var titleSubHero = "Title-module--titleSubHero--D8W0U";
export var txtHorizontal = "Title-module--txtHorizontal--OP2CO";
export var txtVertical = "Title-module--txtVertical--5Odt3";
export var txtHero = "Title-module--txtHero--XMhxB";
export var txtSubHero = "Title-module--txtSubHero--GrObA";